module.exports = __webpack_public_path__ + "img/fi_x.7ee1ef2d.svg";